import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=cbf46b0e"
import script from "./Splash.ts?vue&type=script&lang=js&external"
export * from "./Splash.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports